import React from 'react';
import { SellOnMX } from '@features/homepage';
import SafeImage from '@ui/SafeImage';

const Phone = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.2008 39.9158C32.9164 41.4718 30.5392 44.4664 29.7242 46.3064C29.6355 46.502 29.5344 46.6918 29.4216 46.8745C28.3658 48.6219 26.1676 50.3508 25.0994 51.1226C24.9129 51.2563 24.7649 51.4369 24.6706 51.6462C24.5762 51.8555 24.5389 52.086 24.5623 52.3143V52.5613C24.5795 52.7436 24.5584 52.9275 24.5005 53.1011C24.4425 53.2748 24.3489 53.4344 24.2256 53.5699C24.1024 53.7053 23.9523 53.8135 23.7849 53.8876C23.6174 53.9616 23.4363 53.9999 23.2533 54H18.3136C18.1235 54.0006 17.9356 53.9599 17.7629 53.8806C17.5902 53.8013 17.4368 53.6854 17.3134 53.5409C17.19 53.3963 17.0996 53.2266 17.0484 53.0436C16.9972 52.8606 16.9865 52.6686 17.017 52.481C17.69 48.2576 19.6473 36.6247 20.7217 35.5503L24.6795 31.5986V42.1386C24.6795 42.1386 28.2793 41.7681 30.2367 38.8228C31.6815 37.5138 32.8732 37.5386 33.7068 37.8843C33.8903 37.968 34.052 38.0931 34.179 38.2499C34.306 38.4066 34.3949 38.5907 34.4386 38.7877C34.4823 38.9846 34.4796 39.189 34.4308 39.3848C34.382 39.5806 34.2885 39.7623 34.1576 39.9158"
      fill="#C41719"
    />
    <path
      d="M46.0559 15.5942H24.7352M33.997 44.911H37.1954M34.2008 39.9158C32.9164 41.4718 30.5392 44.4664 29.7242 46.3065C29.6355 46.502 29.5344 46.6918 29.4216 46.8746C28.3658 48.622 26.1676 50.3508 25.0994 51.1227C24.9129 51.2564 24.7649 51.437 24.6706 51.6462C24.5762 51.8555 24.5389 52.086 24.5623 52.3143V52.5613C24.5795 52.7436 24.5584 52.9275 24.5005 53.1012C24.4425 53.2748 24.3489 53.4345 24.2256 53.5699C24.1024 53.7053 23.9523 53.8135 23.7849 53.8876C23.6174 53.9617 23.4363 53.9999 23.2533 54H18.3136C18.1235 54.0007 17.9356 53.9599 17.7629 53.8806C17.5902 53.8014 17.4368 53.6854 17.3134 53.5409C17.19 53.3963 17.0996 53.2266 17.0484 53.0436C16.9972 52.8606 16.9865 52.6686 17.017 52.481C17.69 48.2576 19.6473 36.6247 20.7217 35.5504L24.6795 31.5987V42.1386C24.6795 42.1386 28.2793 41.7682 30.2367 38.8229C31.6815 37.5139 32.8732 37.5386 33.7068 37.8844C33.8903 37.968 34.052 38.0931 34.179 38.2499C34.306 38.4067 34.3949 38.5908 34.4386 38.7877C34.4823 38.9847 34.4796 39.1891 34.4308 39.3848C34.382 39.5806 34.2885 39.7624 34.1576 39.9158H34.2008ZM46.0559 11.3214V45.547C46.0567 45.7208 46.0231 45.8929 45.957 46.0536C45.8909 46.2143 45.7936 46.3603 45.6707 46.4832C45.5479 46.606 45.4019 46.7033 45.2412 46.7694C45.0805 46.8356 44.9084 46.8692 44.7346 46.8684H29.4402C29.553 46.6856 29.654 46.4959 29.7427 46.3003C30.5578 44.4479 32.935 41.4656 34.2193 39.9096C34.3503 39.7562 34.4438 39.5744 34.4926 39.3787C34.5414 39.1829 34.544 38.9785 34.5003 38.7815C34.4566 38.5846 34.3678 38.4005 34.2408 38.2437C34.1138 38.087 33.9521 37.9618 33.7686 37.8782C32.935 37.5324 31.7433 37.5077 30.2985 38.8167C28.3349 41.762 24.7413 42.1325 24.7413 42.1325V11.3214C24.7413 10.972 24.8797 10.6368 25.1261 10.3892C25.3726 10.1416 25.7072 10.0016 26.0565 10H44.7407C45.0912 10 45.4273 10.1392 45.6751 10.387C45.9229 10.6348 46.0621 10.9709 46.0621 11.3214H46.0559Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.4469 24.6709L28.6131 31.0739H30.1752L31.9597 24.6771L30.4469 24.6709Z"
      fill="black"
    />
    <path
      d="M34.4965 24.6829L32.7244 26.6279L32.1131 24.6768L31.4339 26.9614L31.9464 29.246L33.8358 26.9675L34.4965 24.6829Z"
      fill="black"
    />
    <path
      d="M34.3491 31.0861L36.1645 24.6831H34.5961L32.7808 31.08L34.3491 31.0861Z"
      fill="black"
    />
    <path
      d="M37.8127 31.0985H39.5848L38.7883 27.6963L41.2704 24.6954H39.7824L38.4548 26.3255L38.0843 24.6893L36.3246 24.6831L37.0656 27.8877L32.2803 33.5806H33.793L37.399 29.3387L37.8127 31.0985Z"
      fill="black"
    />
    <path
      d="M36.0536 31.4565H35.7881L35.3743 32.9323H36.3376L36.387 32.71L35.7016 32.7038L36.0536 31.4565Z"
      fill="black"
    />
    <path
      d="M37.2142 32.5867L37.0968 32.6916H36.7573L36.6832 32.599L36.9116 31.7963L37.0351 31.7037H37.3562L37.4365 31.7963L37.2142 32.5867ZM37.5476 31.4629H36.9857L36.6832 31.6852L36.4053 32.704L36.5905 32.9448H37.1277L37.4488 32.6916L37.7266 31.6913L37.5476 31.4629Z"
      fill="black"
    />
    <path
      d="M38.387 32.3891L38.3315 32.6114L38.2203 32.6978L37.9116 32.6916L37.8437 32.5867L38.0598 31.8148L38.1894 31.7037L38.5044 31.7099L38.5538 31.8148L38.5167 31.9877H38.7822L38.8563 31.679L38.6834 31.4629H38.1586L37.8252 31.7161L37.5473 32.6793L37.7449 32.951H38.2635L38.5723 32.704L38.6525 32.3953L38.387 32.3891Z"
      fill="black"
    />
    <path
      d="M40.0847 31.4688H39.8007L39.1338 32.0615L39.2944 31.4688H39.0227L38.6028 32.9507H38.8807L39.0289 32.4382L39.282 32.2159L39.424 32.9568H39.6834L39.492 32.0059L40.0847 31.4688Z"
      fill="black"
    />
    <path
      d="M40.221 32.2776L40.7149 32.2838L40.7643 32.08H40.2703L40.363 31.7157H41.0792L41.1471 31.4688H40.1901L39.764 32.9568H40.7273L40.7952 32.7098H40.0975L40.221 32.2776Z"
      fill="black"
    />
    <path
      d="M41.3323 32.105L41.4311 31.7222H41.8201L41.8818 31.7902L41.8324 32.0186L41.7275 32.1174L41.3323 32.105ZM42.0671 32.105L42.1721 31.6852L42.0177 31.4814H41.2583L40.826 32.9695H41.0915L41.2644 32.352H41.4373L41.5423 32.9695H41.8077L41.6966 32.352H41.7707L42.0671 32.105Z"
      fill="black"
    />
  </svg>
);

const Ship = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.3032 12H24.2021L23.0186 16.7341V26.2022L27.7526 23.8352L32.4867 26.2022V16.7341L31.3032 12Z"
      fill="#C41719"
    />
    <path
      d="M46.689 16.7341H10M46.689 16.7341H46.7067L44.5942 12.5148C44.5174 12.3607 44.3993 12.2309 44.253 12.1399C44.1067 12.049 43.938 12.0006 43.7657 12H12.9411C12.7688 12.0006 12.6002 12.049 12.4539 12.1399C12.3076 12.2309 12.1894 12.3607 12.1126 12.5148L10 16.7341M46.689 16.7341V44.2034H10V16.7341M31.3033 12H24.2022L23.0187 16.7341V26.2022L27.7527 23.8351L32.4868 26.2022V16.7341L31.3033 12Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.8936 29.2026L21.0947 35.4871L22.6273 35.493L24.3789 29.2026H22.8936Z"
      fill="black"
    />
    <path
      d="M26.8699 29.2086L25.1301 31.1199L24.5265 29.2026L23.8578 31.4513L24.3667 33.6941L26.2248 31.4572L26.8699 29.2086Z"
      fill="black"
    />
    <path
      d="M26.7225 35.5043L28.5096 29.2139L26.971 29.208L25.1898 35.4984L26.7225 35.5043Z"
      fill="black"
    />
    <path
      d="M30.1317 35.5116L31.8715 35.5176L31.0904 32.1741L33.5285 29.2272H32.0668L30.759 30.8308L30.3921 29.2213L28.6642 29.2153L29.398 32.3635L24.6935 37.9497L26.1788 37.9556L29.7175 33.7837L30.1317 35.5116Z"
      fill="black"
    />
    <path
      d="M28.405 35.8647H28.1446L27.7363 37.3146H28.6772L28.7305 37.1015L28.0559 37.0897L28.405 35.8647Z"
      fill="black"
    />
    <path
      d="M29.5638 36.9787L29.4455 37.0793H29.1141L29.0431 36.9905L29.262 36.1975L29.3803 36.1088H29.6999L29.7828 36.1975L29.5638 36.9787ZM29.8893 35.8721H29.3389L29.0371 36.091L28.765 37.0911L28.9484 37.3337H29.475L29.7887 37.0852L30.0668 36.1029L29.8893 35.8721Z"
      fill="black"
    />
    <path
      d="M30.6948 36.7834L30.6416 37.0023L30.5292 37.0852H30.2274L30.1563 36.9727L30.3753 36.2212L30.4995 36.1147H30.8073L30.8605 36.2153L30.8191 36.3928H31.0795L31.1564 36.0851L30.9848 35.8721H30.464L30.1386 36.1206L29.8664 37.0674L30.0676 37.3337H30.5706L30.8783 37.0911L30.9552 36.7893L30.6948 36.7834Z"
      fill="black"
    />
    <path
      d="M32.3613 35.8774H32.0831L31.4204 36.4574L31.5801 35.8774H31.3198L30.9055 37.3332L31.1777 37.3391L31.3257 36.8302L31.5683 36.6171L31.7044 37.3391H31.9648L31.7813 36.41L32.3613 35.8774Z"
      fill="black"
    />
    <path
      d="M32.4917 36.6763H32.9769L33.0243 36.4751H32.539L32.6337 36.1201H33.3379L33.403 35.8834L32.4621 35.8774L32.042 37.3391H32.9947L33.0598 37.0965H32.3734L32.4917 36.6763Z"
      fill="black"
    />
    <path
      d="M33.5793 36.5104L33.6858 36.1317H34.0645L34.1237 36.2027L34.0764 36.4276L33.9698 36.5223L33.5793 36.5104ZM34.3072 36.5104L34.4137 36.0962L34.2598 35.895H33.5083L33.0881 37.3567H33.3485L33.5143 36.7649H33.6917L33.7864 37.3567H34.0527L33.9462 36.7649H34.0172L34.3072 36.5104Z"
      fill="black"
    />
    <path
      d="M42.8814 33.6833L36.1509 35.0261L34.8081 41.7566C34.7871 41.864 34.7928 41.975 34.8248 42.0798C34.8568 42.1845 34.9141 42.2797 34.9916 42.3571L43.6987 51.0642C43.7601 51.127 43.8334 51.1769 43.9143 51.2109C43.9952 51.245 44.0821 51.2625 44.1699 51.2625C44.2577 51.2625 44.3447 51.245 44.4256 51.2109C44.5065 51.1769 44.5798 51.127 44.6412 51.0642L52.189 43.5163C52.2518 43.455 52.3017 43.3817 52.3357 43.3008C52.3698 43.2198 52.3874 43.1329 52.3874 43.0451C52.3874 42.9573 52.3698 42.8704 52.3357 42.7895C52.3017 42.7086 52.2518 42.6353 52.189 42.5739L43.4819 33.8668C43.4045 33.7893 43.3093 33.732 43.2046 33.7C43.0998 33.668 42.9889 33.6623 42.8814 33.6833Z"
      fill="#C41719"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Dollar = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M53.9997 44.1313V50.2425C53.9997 50.5666 53.8709 50.8775 53.6417 51.1067C53.4124 51.3359 53.1016 51.4647 52.7774 51.4647H46.6663C46.6663 49.5198 47.439 47.6545 48.8142 46.2792C50.1895 44.904 52.0547 44.1313 53.9997 44.1313Z"
      fill="#C41719"
    />
    <path
      d="M53.9997 29.4708V35.5819C52.0547 35.5819 50.1895 34.8093 48.8142 33.434C47.439 32.0587 46.6663 30.1935 46.6663 28.2485H52.7774C53.1016 28.2485 53.4124 28.3773 53.6417 28.6065C53.8709 28.8357 53.9997 29.1466 53.9997 29.4708Z"
      fill="#C41719"
    />
    <path
      d="M17.3333 51.4647H11.2222C10.8981 51.4647 10.5872 51.3359 10.358 51.1067C10.1288 50.8775 10 50.5666 10 50.2425V44.1313C11.9449 44.1313 13.8102 44.904 15.1854 46.2792C16.5607 47.6545 17.3333 49.5198 17.3333 51.4647Z"
      fill="#C41719"
    />
    <path
      d="M17.3333 28.2485C17.3333 30.1935 16.5607 32.0587 15.1854 33.434C13.8102 34.8093 11.9449 35.5819 10 35.5819V29.4708C10 29.1466 10.1288 28.8357 10.358 28.6065C10.5872 28.3773 10.8981 28.2485 11.2222 28.2485H17.3333Z"
      fill="#C41719"
    />
    <path
      d="M54 29.4708V50.2485C54 50.5727 53.8712 50.8836 53.642 51.1128C53.4128 51.342 53.1019 51.4708 52.7778 51.4708H11.2222C10.8981 51.4708 10.5872 51.342 10.358 51.1128C10.1288 50.8836 10 50.5727 10 50.2485V29.4708C10 29.1466 10.1288 28.8357 10.358 28.6065C10.5872 28.3773 10.8981 28.2485 11.2222 28.2485H52.7778C53.1019 28.2485 53.4128 28.3773 53.642 28.6065C53.8712 28.8357 54 29.1466 54 29.4708ZM17.3333 28.2485C17.3333 30.1935 16.5607 32.0587 15.1854 33.434C13.8102 34.8093 11.9449 35.5819 10 35.5819V29.4708C10 29.1466 10.1288 28.8357 10.358 28.6065C10.5872 28.3773 10.8981 28.2485 11.2222 28.2485H17.3333ZM17.3333 51.4708H11.2222C10.8981 51.4708 10.5872 51.342 10.358 51.1128C10.1288 50.8836 10 50.5727 10 50.2485V44.1374C11.9449 44.1374 13.8102 44.91 15.1854 46.2853C16.5607 47.6606 17.3333 49.5258 17.3333 51.4708ZM54 29.4708V35.5819C52.0551 35.5819 50.1898 34.8093 48.8146 33.434C47.4393 32.0587 46.6667 30.1935 46.6667 28.2485H52.7778C53.1019 28.2485 53.4128 28.3773 53.642 28.6065C53.8712 28.8357 54 29.1466 54 29.4708ZM38.435 39.8596C38.4374 41.1329 38.0621 42.3782 37.3565 43.4381C36.6509 44.4979 35.6467 45.3246 34.4711 45.8135C33.2954 46.3024 32.0012 46.4316 30.7521 46.1847C29.503 45.9378 28.3553 45.3259 27.4541 44.4264C26.5529 43.527 25.9388 42.3804 25.6896 41.1318C25.4403 39.8832 25.567 38.5887 26.0537 37.4121C26.5404 36.2356 27.3652 35.2298 28.4237 34.5222C29.4822 33.8146 30.7268 33.4369 32 33.4369C32.8456 33.4369 33.6829 33.6035 34.464 33.9273C35.2451 34.2511 35.9547 34.7256 36.5524 35.3238C37.15 35.922 37.6239 36.6321 37.9469 37.4135C38.2699 38.195 38.4358 39.0324 38.435 39.878V39.8596ZM54 44.1374V50.2485C54 50.5727 53.8712 50.8836 53.642 51.1128C53.4128 51.342 53.1019 51.4708 52.7778 51.4708H46.6667C46.6667 49.5258 47.4393 47.6606 48.8146 46.2853C50.1898 44.91 52.0551 44.1374 54 44.1374Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.9431 40.1592C33.795 39.9252 33.5829 39.7385 33.332 39.6214C33.039 39.4965 32.7338 39.4023 32.4214 39.3403H32.3786H32.3359C32.1432 39.305 31.9532 39.256 31.7675 39.1936C31.6331 39.1479 31.513 39.0679 31.4192 38.9614C31.3193 38.8372 31.2692 38.6804 31.2786 38.5214C31.2774 38.4239 31.2995 38.3276 31.3431 38.2404C31.3867 38.1532 31.4505 38.0778 31.5292 38.0203C31.7426 37.8921 31.9894 37.8304 32.2381 37.8431C32.4667 37.8445 32.6929 37.8901 32.9042 37.9775C33.1433 38.0737 33.3675 38.2033 33.5702 38.3625L34.0714 37.3725C33.8807 37.2332 33.6759 37.1144 33.4603 37.0181C33.265 36.9232 33.0601 36.8495 32.8492 36.7981C32.7963 36.7951 32.7432 36.7951 32.6903 36.7981V36.0464H31.5169V36.8286C31.3659 36.8607 31.2186 36.9078 31.0769 36.9692C30.7727 37.1066 30.5187 37.3351 30.3498 37.6231C30.1762 37.939 30.0897 38.2954 30.0992 38.6558C30.0771 39.0257 30.1711 39.3931 30.368 39.7069C30.5157 39.9354 30.7286 40.1143 30.9791 40.2203C31.2985 40.336 31.6279 40.422 31.9631 40.4769H32.0547C32.2226 40.5078 32.388 40.5507 32.5497 40.6053C32.6721 40.645 32.7804 40.7193 32.8614 40.8192C32.9494 40.9298 32.9929 41.0692 32.9836 41.2103C32.9911 41.3175 32.9702 41.4248 32.923 41.5214C32.8758 41.6179 32.804 41.7003 32.7147 41.7603C32.4852 41.9053 32.2156 41.9737 31.9447 41.9558C31.6463 41.9552 31.3504 41.9014 31.0708 41.7969C30.7949 41.6902 30.5404 41.535 30.3192 41.3386L29.7753 42.3103C29.9131 42.4696 30.0842 42.5969 30.2764 42.6831C30.5318 42.8082 30.8003 42.9045 31.0769 42.9703C31.2117 43.0036 31.3485 43.0281 31.4864 43.0436V43.7769H32.6903V43.0069C32.8535 42.9708 33.0131 42.9196 33.167 42.8542C33.478 42.7235 33.7407 42.4992 33.9186 42.2125C34.101 41.904 34.192 41.5501 34.1814 41.1919C34.2017 40.8429 34.1166 40.4958 33.937 40.1958"
      fill="black"
    />
    <path
      d="M23.8843 28.2484L32.3299 13.6123C32.4102 13.4727 32.5174 13.3505 32.6451 13.2524C32.7729 13.1544 32.9188 13.0827 33.0744 13.0412C33.23 12.9997 33.3922 12.9894 33.5518 13.0109C33.7114 13.0323 33.8652 13.0851 34.0043 13.1662L42.3887 18.0062"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.0047 13.1662L39.297 16.2217C38.8153 17.0562 38.1739 17.7877 37.4095 18.3742C36.645 18.9607 35.7725 19.3908 34.8418 19.64C33.911 19.8891 32.9403 19.9524 31.985 19.8262C31.0298 19.7 30.1088 19.3868 29.2747 18.9045L32.3303 13.6123C32.4106 13.4727 32.5178 13.3505 32.6455 13.2524C32.7733 13.1544 32.9192 13.0827 33.0748 13.0412C33.2304 12.9997 33.3926 12.9894 33.5522 13.0109C33.7118 13.0323 33.8656 13.0851 34.0047 13.1662V13.1662Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.6545 28.2486L44.21 16.9674C44.3492 16.8864 44.503 16.8336 44.6625 16.8122C44.8221 16.7907 44.9844 16.801 45.14 16.8425C45.2956 16.8839 45.4415 16.9557 45.5692 17.0537C45.697 17.1517 45.8041 17.274 45.8845 17.4136L52.1361 28.2486"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.8599 17.4136L48.9155 22.7058C48.0814 23.1881 47.1603 23.5013 46.2051 23.6275C45.2499 23.7537 44.2792 23.6904 43.3484 23.4412C42.4177 23.1921 41.5451 22.762 40.7807 22.1754C40.0162 21.5889 39.3749 20.8575 38.8932 20.023L44.1855 16.9674C44.3246 16.8864 44.4783 16.8336 44.6379 16.8122C44.7975 16.7907 44.9598 16.801 45.1154 16.8425C45.271 16.8839 45.4168 16.9557 45.5446 17.0537C45.6724 17.1517 45.7796 17.274 45.8599 17.4136V17.4136Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.8843 28.2484L32.3299 13.6123C32.4102 13.4727 32.5174 13.3505 32.6451 13.2524C32.7729 13.1544 32.9188 13.0827 33.0744 13.0412C33.23 12.9997 33.3922 12.9894 33.5518 13.0109C33.7114 13.0323 33.8652 13.0851 34.0043 13.1662L42.3887 18.0062"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.0047 13.1662L39.297 16.2217C38.8153 17.0562 38.1739 17.7877 37.4095 18.3742C36.645 18.9607 35.7725 19.3908 34.8418 19.64C33.911 19.8891 32.9403 19.9524 31.985 19.8262C31.0298 19.7 30.1088 19.3868 29.2747 18.9045L32.3303 13.6123C32.4106 13.4727 32.5178 13.3505 32.6455 13.2524C32.7733 13.1544 32.9192 13.0827 33.0748 13.0412C33.2304 12.9997 33.3926 12.9894 33.5522 13.0109C33.7118 13.0323 33.8656 13.0851 34.0047 13.1662V13.1662Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.6545 28.2486L44.21 16.9674C44.3492 16.8864 44.503 16.8336 44.6625 16.8122C44.8221 16.7907 44.9844 16.801 45.14 16.8425C45.2956 16.8839 45.4415 16.9557 45.5692 17.0537C45.697 17.1517 45.8041 17.274 45.8845 17.4136L52.1361 28.2486"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.8599 17.4136L48.9155 22.7058C48.0814 23.1881 47.1603 23.5013 46.2051 23.6275C45.2499 23.7537 44.2792 23.6904 43.3484 23.4412C42.4177 23.1921 41.5451 22.762 40.7807 22.1754C40.0162 21.5889 39.3749 20.8575 38.8932 20.023L44.1855 16.9674C44.3246 16.8864 44.4783 16.8336 44.6379 16.8122C44.7975 16.7907 44.9598 16.801 45.1154 16.8425C45.271 16.8839 45.4168 16.9557 45.5446 17.0537C45.6724 17.1517 45.7796 17.274 45.8599 17.4136V17.4136Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Ellipse = () => (
  <div className="absolute left-0 top-0 -z-10 h-[10rem] w-[10rem] rounded-full bg-white shadow-lg"></div>
);

const Action = ({
  icon,
  title,
  text,
}: {
  icon: React.ReactNode;
  title: string;
  text: string;
}) => (
  <div className="flex items-center justify-start gap-[2.4rem]">
    <div className="flex ">
      <div className="relative flex h-[10rem] w-[10rem] items-center justify-center">
        {icon}
        <Ellipse />
      </div>
    </div>
    <div className="flex flex-col gap-[0.4rem]">
      <h6 className="text-[2.4rem] font-semibold">{title}</h6>
      <span className="text-[1.6rem] font-normal">{text}</span>
    </div>
  </div>
);

const SellOnMxLockerCTA = () => {
  return (
    <div className="relative isolate h-[60rem] bg-[#FAFAFA]">
      <div className="absolute left-[4rem] hidden h-[63rem] w-[58rem] lg:block">
        <SafeImage src={SellOnMX} alt="Sell on MX Locker" fill />
      </div>
      <div className="absolute top-[6.4rem] flex flex-col justify-center gap-[4rem] p-[2.4rem] lg:left-[73rem]">
        <h3 className="text-[2.4rem] font-semibold lg:text-[3.2rem]">
          SELL ON <span className="text-brand-primary">MX LOCKER</span>
        </h3>
        <Action
          icon={<Phone />}
          title={'Sell it.'}
          text={
            'List for free in minutes. Take a few pics. Add a description. Set your price.'
          }
        />
        <Action
          icon={<Ship />}
          title={'Ship it.'}
          text={
            'Save time and money. Print a label directly with us and take advantage of our discounted rates.'
          }
        />
        <Action
          icon={<Dollar />}
          title={'Get Paid.'}
          text={
            'You get paid once the package is delivered. Cash out or treat yourself to the thousands of items on MX Locker.'
          }
        />
      </div>
    </div>
  );
};

export default SellOnMxLockerCTA;
